<!-- Survey Start -->
<div class="bg">
  <div *ngIf="showCaptcha == true" class="form-wrapper d-flex justify-content-center align-items-center"
    style="min-height: 100vh; padding: 1rem">
    <div class="card w-100" style="
      max-width: 550px;
      padding: 2rem 1rem;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    ">
      <div class="card-body">
        <form (ngSubmit)="onSubmit()" #form="ngForm">
          <div class="d-flex justify-content-center">
            <re-captcha siteKey="6LeifBkrAAAAAHbIc-mI2R9M06Oh9JUo5ArIQ2qz"
              (resolved)="onCaptchaResolved($event)"></re-captcha>
          </div>
          <div class="text-center mt-3">
            <button type="submit" class="btn btn_previous" [ngStyle]="{ background: nextButton }">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- <img [src]="brandLocation" alt="" *ngIf="brandLocation != 'Default'" class="mt-5 ml-2" width="100" height="80"> -->
  <div class="container survey-container" [ngStyle]="deskWidth" *ngIf="
      showCaptcha == false &&
      showSurvey == false &&
      showThank == false &&
      showError == false &&
      identify?.identification != 'external'
    ">
    <!-- <img src="/assets/favicon1.png" width="69" class="cursor-pointer"> -->
    <!-- <img [src]="brandLocation" alt="" *ngIf="brandLocation != 'Default'" class="mt-2" width="200" height="100"> -->
    <!-- <ng-container *ngIf="brandLocation">
    <img [src]="brandLocation" alt="" *ngIf="brandLocation != 'Default'" class="mt-2 ml-2 logo_WH" 
      style=" left: 20px;
    position: absolute;">
    </ng-container> -->
    <ng-container *ngIf="brandLocation">
      <img [src]="brandLocation" alt="" *ngIf="brandLocation != 'Default'"
        class="mt-2 ml-2 logo_WH img-fluid d-block d-md-absolute h-auto w-30" style="left: 20px; position: absolute" />
    </ng-container>
    <!-- <div class="row" *ngIf="showCard == true"> -->
    <div class="row" *ngIf="showCard" [ngClass]="{ 'mt-4': showCard }">
      <div class="col-12 col-md-1 col-lg-1 mt-5 pt-5 survey-left-spacer"></div>
      <div class="col-12 col-md-11 col-lg-11 mt-2 mb-5 m-p">
        <div class="card" [ngStyle]="{ 'border-color': nextButton }">
          <div class="card-body {{ surveyDetail?.qID }}" style="padding-bottom: 2.5rem">
            <div class="row">
              <div class="col-lg-12">
                <h5 class="d-inline-block w-100">
                  <!-- <span *ngIf="surveyDetail?.test_mode == 1"
                                    class="d-inline-block">{{surveyDetail?.qID}}:&nbsp;</span> -->
                  <div *ngIf="surveyDetail?.qText">
                    <div *ngFor="let q of surveyDetail?.qText; let i = index">
                      <span *ngIf="q.type == 'string'" class="d-inline-block w-100"
                        [innerHTML]="q.detail | safe : 'html'">{{ q.detail }}
                      </span>
                      <div *ngIf="q.type == 'video'">
                        <video max-width="100%" max-height="100%" controls controlsList="nodownload"
                          class="concept_video1 mt-2" id="con_val{{ q.id }}" (play)="playqTextVideo(q)">
                          <source src="{{ q.detail }}" type="video/mp4" />
                          Your browser does not support video, please change
                          your browser.
                        </video>
                      </div>
                      <div *ngIf="q.type == 'image'">
                        <img src="{{ q.detail }}" class="concept_video1 mt-2" />
                      </div>
                    </div>
                  </div>
                </h5>
              </div>
            </div>

            <h5 data-toggle="modal" data-target="#hyperLink" *ngIf="surveyDetail?.expandedView == 1">
              Click <span class="see-here">here</span> to see again
            </h5>

            <div class="row" *ngIf="surveyDetail?.ri">
              <div class="col-lg-12 mb-2">
                <div [innerHTML]="surveyDetail?.ri | safe : 'html'" style="font-style: italic"></div>
              </div>
            </div>

            <div class="row" *ngIf="
                surveyDetail?.qType == 'max-diff' &&
                surveyDetail?.qText2 != 'string' &&
                surveyDetail?.attributeType != 'Text Only'
              ">
              <div class="col-lg-12 mb-2">
                <div style="font-style: italic">
                  Click on the image to see the large image.
                </div>
              </div>
            </div>

            <div class="row" *ngIf="surveyDetail?.qText2.length > 0">
              <ng-container *ngFor="let q2 of surveyDetail?.qText2; let k = index">
                <div class="col-12 col-lg-12 mt-3 mb-3" *ngIf="q2.type == 'string'">
                  <span class="mb-4" [innerHTML]="q2.detail | safe : 'html'"></span>
                </div>
                <div class="col-12 col-lg-12 mt-3 mb-3 text-center" *ngIf="q2.type == 'video'">
                  <video max-width="100%" max-height="100%" controls controlsList="nodownload"
                    class="mb-2 concept_video1" id="con_val{{ q2.id }}" (play)="playqTextVideo(q2)">
                    <source src="{{ q2.detail }}" type="video/mp4" />
                    Your browser does not support video, please change your
                    browser.
                  </video>
                </div>
                <div class="col-12 col-lg-12 mt-3 mb-3 text-center" *ngIf="q2.type == 'image'">
                  <img src="{{ q2.detail }}" class="concept_video1" />
                </div>
              </ng-container>
            </div>

            <div *ngIf="surveyDetail?.qType == 'open-end-small' && rowList == 0">
              <div class="form-group">
                <input type="number" class="form-control text-center resp_custom" id="dataVal" min="{{ numericMin }}"
                  max="{{ numericMax }}" />
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'open-end-small' && rowList > 0">
              <div class="col-12 col-lg-12" *ngIf="
                  qidD2 == 'd1' ||
                  qidD2 == 'd2' ||
                  qidD2 == 'd3' ||
                  qidD2 == 'd4' ||
                  qidD2 == 'd5' ||
                  qidD2 == 'd6'
                ">
                <form [formGroup]="projectCreation">
                  <table class="table table-bordered ques-width">
                    <tbody>
                      <tr *ngFor="let rw of surveyDetail.rowOptionList">
                        <td *ngIf="rw.optionType == 'open-end-small'">
                          No of people
                          <span [innerHTML]="rw.optionText | safe : 'html'">{{
                            rw.optionText
                            }}</span>
                        </td>
                        <td *ngIf="rw.optionType == 'open-end-small'" class="text-center">
                          <div>
                            <input type="number" (keyup)="preventInput($event)" class="getName text-center in-width"
                              min="{{ numericMin }}" max="{{ numericMax }}" id="opendEndPeople"
                              formControlName="projectpeople" name="{{ rw.var }}" />
                          </div>
                        </td>
                        <td *ngIf="rw.exclusive == 1">
                          <span [innerHTML]="rw.optionText | safe : 'html'">{{
                            rw.optionText
                            }}</span>
                        </td>
                        <td *ngIf="rw.exclusive == 1" class="text-center">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input preferNot" id="notPrefer"
                              value="{{ rw.var }}" name="example1" (change)="openEndNat($event, rw)" />
                            <label class="custom-control-label" for="notPrefer"></label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </form>
              </div>
              <div class="col-12 col-lg-12" *ngIf="
                  qidD2 != 'd1' &&
                  qidD2 != 'd2' &&
                  qidD2 != 'd3' &&
                  qidD2 != 'd4' &&
                  qidD2 != 'd5' &&
                  qidD2 != 'd6'
                ">
                <form [formGroup]="projectCreation">
                  <div class="row" *ngFor="let rw of surveyDetail.rowOptionList">
                    <div class="col-lg-12" *ngIf="rw.optionType == 'open-end-small'">
                      <input type="number" (keyup)="preventInput($event)"
                        class="getName form-control text-center resp_custom" min="{{ numericMin }}"
                        max="{{ numericMax }}" id="opendEndPeople" formControlName="projectpeople"
                        name="{{ rw.var }}" />
                    </div>
                    <div class="col-12 col-lg-12 mt-3" *ngIf="rw.exclusive == 1">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input preferNot" id="notPrefer"
                          value="{{ rw.var }}" name="example1" (change)="openEndNat($event, rw)" />
                        <label class="custom-control-label" for="notPrefer"><span
                            [innerHTML]="rw.optionText | safe : 'html'">{{
                            rw.optionText
                            }}</span></label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'open-end-medium' && rowList == 0">
              <div class="form-group">
                <input type="text" class="form-control" style="width: 70%" id="openEndMedium" />
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'open-end-medium' && rowList > 0">
              <div class="row" *ngFor="
                  let dataMedium of surveyDetail.rowOptionList;
                  let last = last;
                  let i = index
                ">
                <div class="col-lg-12">
                  <div class="form-group" *ngIf="dataMedium.optionType == 'open-end-medium'">
                    <input class="form-control" style="width: 70%" id="openEndMedium" (keyup)="getopEndMd($event)"
                      name="{{ dataMedium.var }}" />
                  </div>
                </div>
                <div class="col-lg-12" *ngIf="dataMedium.optionType == 'single-select'">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input openEndNot" id="op_end_md"
                      value="{{ dataMedium.var }}" name="example1" (change)="openEndMd($event)" />
                    <label class="custom-control-label" for="op_end_md">
                      <span [innerHTML]="dataMedium.optionText | safe : 'html'">{{ dataMedium.optionText }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'open-end-large' && rowList == 0">
              <div class="form-group">
                <textarea class="form-control" rows="5" id="opLarge"></textarea>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'open-end-large' && rowList > 0">
              <div class="row" *ngFor="
                  let data of surveyDetail.rowOptionList;
                  let last = last;
                  let i = index
                ">
                <div class="col-lg-12">
                  <div class="form-group" *ngIf="data.optionType == 'open-end-large'">
                    <textarea class="form-control" rows="5" id="opLarge" (keyup)="getopEnd($event)"
                      name="{{ data.var }}"></textarea>
                  </div>
                </div>
                <div class="col-lg-12" *ngIf="data.optionType == 'single-select'">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input openEndNot" id="op_end_lg" value="{{ data.var }}"
                      name="example1" (change)="openEndL($event)" />
                    <label class="custom-control-label" for="op_end_lg">
                      <span [innerHTML]="data.optionText | safe : 'html'">{{
                        data.optionText
                        }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'multiple-select'">
              <div class="row">
                <div class="col-lg-12" *ngFor="
                    let list of surveyDetail.rowOptionList;
                    let i = index;
                    let last = last
                  ">
                  <div class="custom-control custom-checkbox mt-1">
                    <input type="checkbox" class="custom-control-input multiselect" id="list{{ i }}"
                      value="{{ list.var }}" attr.other="{{ list.other }}" name="{{ list.exclusive }}"
                      (change)="multiSelect($event, list)" />
                    <label class="custom-control-label cursor-pointer" for="list{{ i }}">
                      <ng-container *ngFor="let ql of list.optionText">
                        <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                        </span>
                        <div *ngIf="ql.type == 'video'">
                          <video class="video-full{{ ql.id }} optionImgMulti" (play)="playVideo(ql, i, last)"
                            max-width="100%" max-height="100%" controls controlsList="nodownload"
                            id="con_val_op{{ ql.id }}">
                            <source src="{{ ql.detail }}" type="video/mp4" />
                            Your browser does not support video, please change
                            your browser.
                          </video>
                        </div>
                        <div *ngIf="ql.type == 'image'">
                          <img src="{{ ql.detail }}" class="optionImgMulti" />
                        </div>
                      </ng-container>
                    </label>
                    <div *ngIf="list.other == 1" class="otMl">
                      <input type="text" class="getOthers otherBox oth{{ list.var }}" id="opendEndPeople"
                        name="list{{ i }}" attr.var="{{ list.var }}" (change)="othersMultiple($event, list)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'single-select'">
              <div class="row">
                <div class="col-lg-12">
                  <div class="custom-control custom-radio mt-1" *ngFor="
                      let sin of surveyDetail.rowOptionList;
                      let i = index;
                      let last = last
                    ">
                    <input type="radio" class="custom-control-input allSingleSelect" id="sin{{ i }}"
                      name="{{ sin.var }}" value="{{ sin.optionCode }}" attr.getOther="{{ sin.other }}"
                      (change)="singleSelect($event)" />
                    <label class="custom-control-label cursor-pointer sn-clr" for="sin{{ i }}">
                      <ng-container *ngFor="let ql of sin.optionText">
                        <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                        </span>
                        <div *ngIf="ql.type == 'video'">
                          <video class="video-full{{ ql.id }} optionImgMulti" (play)="playVideo(ql, i, last)"
                            max-width="100%" max-height="100%" controls controlsList="nodownload"
                            id="con_val_op{{ ql.id }}">
                            <source src="{{ ql.detail }}" type="video/mp4" />
                            Your browser does not support video, please change
                            your browser.
                          </video>
                        </div>
                        <div *ngIf="ql.type == 'image'">
                          <img src="{{ ql.detail }}" class="optionImgMulti" />
                        </div>
                      </ng-container>
                    </label>
                    <span *ngIf="sin.other == 1">
                      &nbsp;<input type="text" class="in-other d-inline-block othSin{{ sin.var }}{{
                          sin.optionCode
                        }} sigdata" name="sin{{ i }}" (change)="singleOther($event, sin)" />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- UI For MaxDiff template For testing -->

            <div *ngIf="surveyDetail?.qType == 'max-diff'">
              <ng-container *ngFor="let screen of surveyDetail.attributeSeq; let i = index">
                <div class="row" *ngIf="currentSet == screen.set">
                  <span class="ml-3 mb-1">({{ currentSet }} of
                    {{ surveyDetail.attributeData[0].numberOfScreens }})</span>
                  <div class="res col-lg-12 max_border table-responsive">
                    <table class="table table-bordered ">
                      <thead class="res_mob">
                        <tr class="res_mob3">
                          <th scope="col" class="h_bg" style="width: 60%"></th>
                          <th *ngFor="
                              let cl of surveyDetail.colOptionList;
                              let last = last;
                              let a = index
                            " class="h_bg text-center maxdiff-col-th" style="width: 20%">
                            <ng-container *ngFor="let ql of cl.optionText">
                              <span *ngIf="ql.type == 'string'" class="text_res"
                                [innerHTML]="ql.detail | wordLineBreak | safe : 'html'">
                              </span>
                              <div *ngIf="ql.type == 'image'" class="text-center">
                                <img [src]="ql.detail" width="220" height="220" class="optionImgMax"
                                  alt="Option Image" />
                              </div>
                            </ng-container>
                          </th>
                        </tr>
                      </thead>
                      <tbody class="res_mob2">
                        <tr *ngFor="
                            let grid of screen.items;
                            let last = last;
                            let j = index
                          " class="res_mob2 res_mob3">
                          <td style="width: 60%" class="v-a-middle" scope="row" [ngClass]="
                              screen.values['maxW'] == grid
                                ? 'bg_arti'
                                : screen.values['maxB'] == grid
                                ? 'bg_approved'
                                : ''
                            ">
                            <ng-container *ngIf="
                                surveyDetail.textPosition != 'Above Image' &&
                                surveyDetail.textPosition != 'Below Image'
                              ">
                              <ng-container *ngFor="
                                  let ql of getRowOption(grid).optionText;
                                  let k = index
                                ">
                                <span *ngIf="
                                    ql.type == 'string' &&
                                    surveyDetail.attributeType != 'Image Only'
                                  " [innerHTML]="ql.detail | safe : 'html'">
                                </span>
                                <div *ngIf="ql.type == 'image'" class="text-center">
                                  <img [src]="ql.detail" width="220" height="220" class="optionImgMax"
                                    alt="Option Image" (click)="openImagePopup(ql.detail)"
                                    (keydown.enter)="openImagePopup(ql.detail)" role="button" tabindex="0"
                                    aria-label="View larger image" />
                                </div>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="surveyDetail.textPosition == 'Above Image'">
                              <ng-container *ngFor="
                                  let ql of getRowOption(grid).optionText;
                                  let k = index
                                ">
                                <div *ngIf="
                                    ql.type == 'string' &&
                                    surveyDetail?.attributeType != 'Image Only'
                                  " class="text-center" [innerHTML]="ql.detail | safe : 'html'">
                                </div>
                                <div *ngIf="ql.type == 'image'" class="text-center">
                                  <img [src]="ql.detail" width="220" height="220" class="optionImgMax"
                                    alt="Option Image" (click)="openImagePopup(ql.detail)"
                                    (keydown.enter)="openImagePopup(ql.detail)" role="button" tabindex="0"
                                    aria-label="View larger image" />
                                </div>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="surveyDetail.textPosition == 'Below Image'">
                              <ng-container *ngFor="
                                  let ql of getRowOption(grid).optionText;
                                  let k = index
                                ">
                                <div *ngIf="ql.type == 'image'" class="text-center">
                                  <img [src]="ql.detail" width="220" height="220" class="optionImgMax"
                                    alt="Option Image" (click)="openImagePopup(ql.detail)"
                                    (keydown.enter)="openImagePopup(ql.detail)" role="button" tabindex="0"
                                    aria-label="View larger image" />
                                </div>
                              </ng-container>

                              <ng-container *ngFor="
                                  let ql of getRowOption(grid).optionText;
                                  let k = index
                                ">
                                <div *ngIf="
                                    ql.type == 'string' &&
                                    surveyDetail?.attributeType != 'Image Only'
                                  " class="text-center" [innerHTML]="ql.detail | safe : 'html'">
                                </div>
                              </ng-container>
                            </ng-container>
                            <div *ngIf="getRowOption(grid).other == 1" style="display: inline-block; margin-left: 20px">
                              <input type="text" class="form-control" id="{{ getRowOption(grid).var }}_other" />
                            </div>
                          </td>
                          <td *ngFor="
                              let cl of surveyDetail.colOptionList;
                              let k = index
                            " class="input_cell v-a-middle" style="width: 20% !important">
                            <!-- {{screen.values['maxB'] == grid}} -->
                            <div class="custom-control custom-radio" *ngIf="showPopup == false">
                              <input type="radio" class="custom-control-input gridSelect rwGrid_{{
                                  getRowOption(grid).var
                                }}" *ngIf="k == 0" [disabled]="screen.values['maxW'] == grid" id="maxdiff_{{
                                  screen.set + '_' + grid + '_' + k
                                }}" [(ngModel)]="screen.values['maxB']" name="maxdiff_{{
                                  screen.set + '_' + grid + '_' + k
                                }}" value="{{ grid }}" />
                              <input type="radio" class="custom-control-input gridSelect rwGrid_{{
                                  getRowOption(grid).var
                                }}" *ngIf="k == 1" [disabled]="screen.values['maxB'] == grid" id="maxdiff_{{
                                  screen.set + '_' + grid + '_' + k
                                }}" [(ngModel)]="screen.values['maxW']" name="maxdiff_{{
                                  screen.set + '_' + grid + '_' + k
                                }}" value="{{ grid }}" />
                              <label class="custom-control-label cursor-pointer" for="maxdiff_{{
                                  screen.set + '_' + grid + '_' + k
                                }}"></label>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-container>
            </div>

            <div *ngIf="surveyDetail?.qType == 'single-select-drop-down'">
              <div class="row">
                <div class="col-lg-12">
                  <!-- <select class="form-control drop_stl mt-3" id="drop_down_{{surveyDetail?.var}}">
                    <option value="">Select option</option>
                    <ng-container *ngFor="let sin of surveyDetail.rowOptionList; let i=index">
                      <option value="{{sin.optionCode}}" *ngFor="let ql of sin.optionText;">
                        <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe: 'html'"></span>
                      </option>
                    </ng-container>
                  </select> -->
                  <!-- <div class="dropdown mt-3">
                    <button class="form-control dropdown-toggle text-start" type="button" (click)="toggleDropdown()">
                      <span *ngIf="!selectedOptionDDSC">Select option</span>
                      <span *ngIf="selectedOptionDDSC" [innerHTML]="getOptionHTML(selectedOptionDDSC)"></span>
                      <i *ngIf="selectedOptionDDSC?.fixed == 1" class="fa-solid fa-lock-keyhole set_fix ms-auto" title="Fixed"></i>
                    </button>
                  
                    <ul class="dropdown-menu show w-100" *ngIf="isDropdownOpen">
                      <li *ngFor="let sin of surveyDetail.rowOptionList">
                        <div class="dropdown-item" (click)="selectOption(sin)">
                          <ng-container *ngFor="let ql of sin.optionText">
                            <span *ngIf="ql.type === 'string'" [innerHTML]="ql.detail"></span>
                          </ng-container>
                        </div>
                      </li>
                    </ul>
                  </div> -->
                  <div class="dropdown mt-3">
                    <button class="form-control dropdown-toggle text-start" type="button"
                      (click)="toggleDropdown(surveyDetail.var)">
                      <span *ngIf="!selectedOptionDDSCMap[surveyDetail.var]">Select option</span>
                      <span *ngIf="selectedOptionDDSCMap[surveyDetail.var]" [innerHTML]="
                          getOptionHTML(selectedOptionDDSCMap[surveyDetail.var])
                        "></span>
                      <i *ngIf="
                          selectedOptionDDSCMap[surveyDetail.var]?.fixed == 1
                        " class="fa-solid fa-lock-keyhole set_fix ms-auto" title="Fixed"></i>
                    </button>

                    <ul class="dropdown-menu show w-100" *ngIf="isDropdownOpenMap[surveyDetail.var]">
                      <li *ngFor="let sin of surveyDetail.rowOptionList">
                        <div class="dropdown-item" (click)="selectOption(sin, surveyDetail.var)">
                          <ng-container *ngFor="let ql of sin.optionText">
                            <span *ngIf="ql.type === 'string'" [innerHTML]="ql.detail"></span>
                          </ng-container>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'grid-row-single-select-carousel'">
              <div class="t-center">
                <div id="gridCarusole" class="show_desk bst-car carousel slide" data-ride="carousel"
                  data-interval="false">
                  <div class="carousel-inner getRow" role="listbox" [ngClass]="{
                      'p-none': surveyDetail?.hasVideo == 1 && videoPlayed == 0
                    }">
                    <div class="carousel-item" *ngFor="
                        let row of surveyDetail.rowOptionList;
                        let i = index;
                        let last = last
                      " [ngClass]="{ active: i == 0 }">
                      <div class="total-row show_desk" [ngClass]="{ 'carousel-radio-desk': columnLen > 7 }">
                        {{ i + 1 }} of {{ rowList }}
                      </div>
                      <div class="view hm-black-light">
                        <ng-container *ngFor="let qtxt of row.optionText">
                          <div class="show_desk" [ngClass]="{ 'carousel-radio-desk': columnLen > 7 }">
                            <span *ngIf="qtxt.type == 'string'" class="fnt-20"
                              [innerHTML]="qtxt.detail | safe : 'html'">
                            </span>
                            <div *ngIf="qtxt.type == 'video'">
                              <video class="video-full{{ qtxt.id }} optionImg" (play)="playVideo(qtxt, i, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ qtxt.id }}">
                                <source src="{{ qtxt.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="qtxt.type == 'image'">
                              <img src="{{ qtxt.detail }}" class="optionImg" />
                            </div>
                          </div>
                        </ng-container>
                        <div class="col-lg-12 mt-4" *ngIf="columnLen <= 7">
                          <div class="row" [ngStyle]="getContainerStyle()">
                            <div *ngFor="
                                let cl of surveyDetail.colOptionList;
                                let x = index
                              " [ngStyle]="responsiveWidth()" class="ml-2 mb-5 shadow carousel_border">
                              <input type="radio" class="button carusoleOptions" id="cl{{ cl.optionCode }}{{ i }}"
                                name="{{ row.var }}" value="{{ cl.optionCode }}" (click)="getData($event, last)" />
                              <label for="cl{{ cl.optionCode }}{{ i }}" class="custom-label cursor-pointer box_input pe-none{{
                                  x
                                }}_{{ i }}" [ngStyle]="{
                                  background: nextButton,
                                  color: accent
                                }" [ngClass]="{
                                  'p-none':
                                    row.hasVideo == 1 && videoPlayed == 0
                                }">
                                <ng-container *ngFor="let q of cl.optionText">
                                  <span *ngIf="q.type == 'string'" class="fnt-20"
                                    [innerHTML]="q.detail | safe : 'html'">
                                    {{ q.detail }}
                                  </span>
                                  <div *ngIf="q.type == 'video'">
                                    <video class="video-full{{ q.id }} optionImg" (play)="playVideo(q, i, last)"
                                      max-width="100%" max-height="100%" controls controlsList="nodownload"
                                      id="con_val_op{{ q.id }}">
                                      <source src="{{ q.detail }}" type="video/mp4" />
                                      Your browser does not support video,
                                      please change your browser.
                                    </video>
                                  </div>
                                  <div *ngIf="q.type == 'image'">
                                    <img src="{{ q.detail }}" class="optionImg" />
                                  </div>
                                </ng-container>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12 pl-3 mt-3 carousel-radio-desk" *ngIf="columnLen > 7">
                          <div class="custom-control custom-radio" *ngFor="
                              let cl of surveyDetail.colOptionList;
                              let x = index
                            ">
                            <input type="radio" class="custom-control-input carusoleOptions"
                              (click)="getData($event, last)" id="cl{{ cl.optionCode }}{{ i }}" name="{{ row.var }}"
                              value="{{ cl.optionCode }}" />
                            <label class="custom-control-label pe-none{{
                                x
                              }}_{{ i }}" for="cl{{ cl.optionCode }}{{ i }}" [ngClass]="{
                                'p-none': row.hasVideo == 1 && videoPlayed == 0
                              }">
                              <ng-container *ngFor="let q of cl.optionText">
                                <span *ngIf="q.type == 'string'" class="fnt-20"
                                  [innerHTML]="q.detail | safe : 'html'">
                                </span>
                                <div *ngIf="q.type == 'video'">
                                  <video class="video-full{{ q.id }} optionImg" (play)="playVideo(q, i, last)"
                                    max-width="100%" max-height="100%" controls controlsList="nodownload"
                                    id="con_val_op{{ q.id }}">
                                    <source src="{{ q.detail }}" type="video/mp4" />
                                    Your browser does not support video,
                                    please change your browser.
                                  </video>
                                </div>
                                <div *ngIf="q.type == 'image'">
                                  <img src="{{ q.detail }}" class="optionImg" />
                                </div>
                              </ng-container>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="owl-nav ng-star-inserted">
                        <div *ngIf="i > 0">
                          <a class="carousel-control-prev" (click)="pauseVid(row)" id="prev{{ i }}" href="#gridCarusole"
                            role="button" data-slide="prev">
                            <div class="owl-prev">
                              <div class="nav-btn prev-slide" [ngClass]="{ 'd-none': columnLen > 7 }"></div>
                            </div>
                          </a>
                        </div>
                        <div *ngIf="last == false">
                          <a class="carousel-control-next d-none" (click)="pauseVid(row)" id="next{{ i }}"
                            href="#gridCarusole" role="button" data-slide="next">
                            <div class="owl-next">
                              <div class="nav-btn next-slide" [ngClass]="{ 'd-none': columnLen > 7 }"></div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="gridCarusoleMob" class="show_mob bst-car carousel slide" data-ride="carousel"
                  data-interval="false">
                  <div class="carousel-inner" role="listbox">
                    <div class="carousel-item" *ngFor="
                        let row of surveyDetail.rowOptionList;
                        let i = index;
                        let last = last
                      " [ngClass]="{ active: i == 0 }">
                      <div class="row getRow" [ngClass]="{
                          'p-none':
                            surveyDetail?.hasVideo == 1 && videoPlayed == 0
                        }">
                        <div class="col-lg-12">
                          <span>{{ i + 1 }} of {{ rowList }}</span><br />
                          <div *ngFor="let qtxt of row.optionText; let k = index">
                            <span *ngIf="qtxt.type == 'string'" class="fnt-20"
                              [innerHTML]="qtxt.detail | safe : 'html'">
                            </span>
                            <div *ngIf="qtxt.type == 'video'">
                              <video max-width="100%" max-height="100%" (play)="playVideo(qtxt, i, last)" controls
                                controlsList="nodownload" class="concept_video1" id="con_val_mob{{ qtxt.id }}">
                                <source src="{{ qtxt.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="qtxt.type == 'image'">
                              <img src="{{ qtxt.detail }}" class="concept_video1" />
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12 pl-3 mt-3">
                          <div class="custom-control custom-radio" *ngFor="
                              let cl of surveyDetail.colOptionList;
                              let k = index
                            ">
                            <input type="radio" class="custom-control-input carusoleOptions"
                              (click)="getData($event, last)" id="clTr{{ cl.optionCode }}{{ i }}" name="{{ row.var }}"
                              value="{{ cl.optionCode }}" />
                            <label class="custom-control-label pe-none-mob{{ k }}_{{
                                i
                              }}" for="clTr{{ cl.optionCode }}{{ i }}" [ngClass]="{
                                'p-none': row.hasVideo == 1 && videoPlayed == 0
                              }">
                              <div *ngFor="
                                  let qtxt of cl.optionText;
                                  let i = index
                                ">
                                <span *ngIf="qtxt.type == 'string'" class="fnt-20"
                                  [innerHTML]="qtxt.detail | safe : 'html'">
                                </span>
                                <div *ngIf="qtxt.type == 'video'">
                                  <video max-width="100%" max-height="100%" (play)="playVideo(qtxt, k, last)" controls
                                    controlsList="nodownload" class="concept_video1" id="con_val_mob{{ qtxt.id }}">
                                    <source src="{{ qtxt.detail }}" type="video/mp4" />
                                    Your browser does not support video, please
                                    change your browser.
                                  </video>
                                </div>
                                <div *ngIf="qtxt.type == 'image'">
                                  <img src="{{ qtxt.detail }}" class="concept_video1" />
                                </div>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="owl-nav ng-star-inserted">
                        <div *ngIf="i > 0">
                          <a class="carousel-control-prev" (click)="pauseVid(row)" id="prev{{ i }}"
                            href="#gridCarusoleMob" role="button" data-slide="prev">
                            <div class="owl-prev">
                              <div class="nav-btn prev-slide"></div>
                            </div>
                          </a>
                        </div>
                        <div *ngIf="last == false">
                          <a class="carousel-control-next mob-next d-none" (click)="pauseVid(row)" id="next{{ i }}"
                            href="#gridCarusoleMob" role="button" data-slide="next">
                            <div class="owl-next">
                              <div class="nav-btn next-slide"></div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="surveyDetail?.qType == 'grid-row-single-select'" class="scroll-wrapper">
              <!-- Main table container -->
              <div class="table-scroll-container">
                <div class="scrollbar-top" id="scrollTop" #scrollTop (scroll)="syncScroll('top')">
                  <div [style.width]="topScrollWidth"></div>
                </div>
                <div class="table-scroll-wrapper table-responsive" id="scrollBottom" #scrollBottom
                  (scroll)="syncScroll('bottom')">

                  <table class="table table-bordered table-resp showOrNot freeze-table grid_table"
                    [ngStyle]="{ 'min-width': tableMinWidth}">
                    <thead>
                      <tr>
                        <!-- <th></th> -->
                        <th class="sticky-col first-col bg-white z-index-2"></th>
                        <th *ngFor="
                            let cl of surveyDetail.colOptionList;
                            let last = last;
                            let a = index
                          " class="text-center v-a-bottom sticky-header bg-white" [ngStyle]="responsiveHeaderWidthGrid(cl)">
                          <ng-container *ngFor="let ql of cl.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} optionImg" (play)="playVideo(ql, a, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="optionImg" />
                            </div>
                          </ng-container>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="
                          let grid of surveyDetail.rowOptionList;
                          let last = last;
                          let j = index
                        ">
                        <td class="v-a-middle sticky-col first-col bg-white">
                          <ng-container *ngFor="let ql of grid.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} optionImg" (play)="playVideo(ql, j, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="optionImg" />
                            </div>
                          </ng-container>
                          <div *ngIf="grid.other == 1" style="display: inline-block; margin-left: 20px">
                            <input type="text" style="width: 70%" class="form-control" id="{{ grid.var }}_other" />
                          </div>
                        </td>
                        <td *ngFor="
                            let cl of surveyDetail.colOptionList;
                            let k = index
                          " class="input_cell v-a-middle" [ngStyle]="responsiveWidthGrid()">
                          <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input gridSelect rwGrid_{{
                                grid.var
                              }}" id="rwgrd{{ grid.var }}_{{ k }}" name="{{ grid.var }}" value="{{ cl.optionCode }}" />
                            <label class="custom-control-label cursor-pointer"
                              for="rwgrd{{ grid.var }}_{{ k }}"></label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-lg-12 showGrid">
                <div class="row">
                  <div class="col-lg-12" *ngFor="
                      let grid of surveyDetail.rowOptionList;
                      let j = index;
                      let last = last
                    ">
                    <ng-container *ngFor="let ql of grid.optionText">
                      <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                      </span>
                      <div *ngIf="ql.type == 'video'">
                        <video class="video-full{{ ql.id }} concept_video1" (play)="playVideo(ql, j, last)"
                          max-width="100%" max-height="100%" controls controlsList="nodownload"
                          id="con_val_op{{ ql.id }}">
                          <source src="{{ ql.detail }}" type="video/mp4" />
                          Your browser does not support video, please change
                          your browser.
                        </video>
                      </div>
                      <div *ngIf="ql.type == 'image'">
                        <img src="{{ ql.detail }}" class="concept_video1" />
                      </div>
                    </ng-container>
                    <div *ngIf="grid.other == 1">
                      <div class="form-group">
                        <input type="text" class="form-control" id="{{ grid.var }}_otherMob" />
                      </div>
                    </div>
                    <div class="form-group">
                      <select class="form-control" id="{{ grid.var }}_opCode">
                        <option value="">Select option</option>
                        <option *ngFor="let cl of surveyDetail.colOptionList" value="{{ cl.optionCode }}">
                          <ng-container *ngFor="let ql of cl.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} concept_video1" (play)="playVideo(ql, j, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="concept_video1" />
                            </div>
                          </ng-container>
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="scroll-wrapper" *ngIf="
                surveyDetail?.qType == 'grid-column-single-select' &&
                (surveyDetail?.qID == 'q2' || surveyDetail?.qID == 'Q2')
              ">
              <div class="table-scroll-container">
                <div class="scrollbar-top" id="scrollTop" #scrollTop (scroll)="syncScroll('top')">
                  <div [style.width]="topScrollWidth"></div>
                </div>
                <div class="table-scroll-wrapper table-responsive" id="scrollBottom" #scrollBottom
                  (scroll)="syncScroll('bottom')">
                  <table class="table table-bordered table-resp freeze-table grid_table"
                    [ngStyle]="{ 'min-width': tableMinWidth }">
                    <thead>
                      <tr>
                        <th class="sticky-col first-col bg-white z-index-2"></th>
                        <th *ngFor="
                            let cl of surveyDetail.colOptionList;
                            let last = last;
                            let a = index
                          " class="text-center sticky-header bg-white" [ngStyle]="responsiveHeaderWidthGrid(cl)">
                          <ng-container *ngFor="let ql of cl.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} optionImg" (play)="playVideo(ql, a, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="optionImg" />
                            </div>
                            <input type="hidden" value="{{ ql.detail }}" class="text-center columnOptions" />
                          </ng-container>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="
                          let fav of surveyDetail.rowOptionList;
                          let last = last;
                          let j = index
                        ">
                        <td class="sticky-col first-col">
                          <ng-container *ngFor="let ql of fav.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} optionImg" (play)="playVideo(ql, j, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="optionImg" />
                            </div>
                          </ng-container>
                        </td>
                        <td *ngFor="let cl of surveyDetail.colOptionList" class="input_cell"
                          [ngStyle]="responsiveWidthGrid()">
                          <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input favorite"
                              id="rw{{ cl.var }}_{{ fav.optionCode }}" name="{{ cl.var }}" value="{{ fav.optionCode }}"
                              (click)="getFavData($event)" />
                            <label class="custom-control-label cursor-pointer"
                              for="rw{{ cl.var }}_{{ fav.optionCode }}"></label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="scroll-wrapper" *ngIf="
                surveyDetail?.qType == 'grid-column-single-select' &&
                surveyDetail?.qID != 'q2' &&
                surveyDetail?.qID != 'Q2'
              ">
              <div class="table-scroll-container">
                <div class="scrollbar-top" id="scrollTop" #scrollTop (scroll)="syncScroll('top')">
                  <div [style.width]="topScrollWidth"></div>
                </div>
                <div class="table-scroll-wrapper table-responsive" id="scrollBottom" #scrollBottom
                  (scroll)="syncScroll('bottom')">
                  <table class="table table-bordered freeze-table grid_table table-resp showOrNot"
                    [ngStyle]="{ 'min-width': tableMinWidth }">
                    <thead>
                      <tr>
                        <th class="sticky-col first-col bg-white z-index-2"></th>
                        <th *ngFor="
                            let cl of surveyDetail.colOptionList;
                            let last = last;
                            let a = index
                          " class="text-center v-a-bottom sticky-header bg-white" [ngStyle]="responsiveHeaderWidthGrid(cl)">
                          <ng-container *ngFor="let ql of cl.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} optionImg" (play)="playVideo(ql, a, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="optionImg" />
                            </div>
                          </ng-container>
                          <div *ngIf="cl.other == 1" style="display: inline-block; margin-left: 20px">
                            <input type="text" style="width: 70%" class="form-control" id="{{ cl.var }}_other" />
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="
                          let grid of surveyDetail.rowOptionList;
                          let last = last;
                          let j = index
                        ">
                        <td class="sticky-col first-col">
                          <ng-container *ngFor="let ql of grid.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} optionImg" (play)="playVideo(ql, j, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="optionImg" />
                            </div>
                          </ng-container>
                        </td>
                        <td *ngFor="let cl of surveyDetail.colOptionList" class="input_cell v-a-middle"
                          [ngStyle]="responsiveWidthGrid()">
                          <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input gridSelectCol"
                              id="rwCol{{ cl.var }}_{{ grid.optionCode }}" name="{{ cl.var }}"
                              value="{{ grid.optionCode }}" />
                            <label class="custom-control-label cursor-pointer"
                              for="rwCol{{ cl.var }}_{{ grid.optionCode }}"></label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-lg-12 showGrid">
                <div class="row">
                  <div class="col-lg-12" *ngFor="
                      let colGrid of surveyDetail.colOptionList;
                      let a = index;
                      let last = last
                    ">
                    <!-- <span [innerHTML]="colGrid.optionText">{{colGrid.optionText}}</span> -->
                    <ng-container *ngFor="let ql of colGrid.optionText">
                      <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                      </span>
                      <div *ngIf="ql.type == 'video'">
                        <video class="video-full{{ ql.id }} concept_video1" (play)="playVideo(ql, a, last)"
                          max-width="100%" max-height="100%" controls controlsList="nodownload"
                          id="con_val_op{{ ql.id }}">
                          <source src="{{ ql.detail }}" type="video/mp4" />
                          Your browser does not support video, please change
                          your browser.
                        </video>
                      </div>
                      <div *ngIf="ql.type == 'image'">
                        <img src="{{ ql.detail }}" class="concept_video1" />
                      </div>
                    </ng-container>
                    <div *ngIf="colGrid.other == 1">
                      <div class="form-group">
                        <input type="text" class="form-control" id="{{ colGrid.var }}_otherMob_col" />
                      </div>
                    </div>

                    <div class="form-group">
                      <select class="form-control" id="{{ colGrid.var }}_opCode_col">
                        <option value="">Select option</option>
                        <option *ngFor="let rw of surveyDetail.rowOptionList" value="{{ rw.optionCode }}">
                          <!-- <span [innerHTML]="rw.optionText">{{rw.optionText}}</span> -->
                          <ng-container *ngFor="let ql of rw.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} concept_video1" (play)="playVideo(ql, a, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="concept_video1" />
                            </div>
                          </ng-container>
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'grid-row-multiple-select'" class="scroll-wrapper">
              <div class="table-scroll-container">
                <div class="scrollbar-top" id="scrollTop" #scrollTop (scroll)="syncScroll('top')">
                  <div [style.width]="topScrollWidth"></div>
                </div>
                <div class="table-scroll-wrapper table-responsive" id="scrollBottom" #scrollBottom
                  (scroll)="syncScroll('bottom')">
                  <table class="table table-bordered table-resp showOrNot freeze-table grid_table"
                    [ngStyle]="{ 'min-width': tableMinWidth }">
                    <thead>
                      <tr>
                        <th class="sticky-col first-col bg-white z-index-2"></th>
                        <th *ngFor="
                            let cl of surveyDetail.colOptionList;
                            let last = last;
                            let a = index
                          " class="text-center v-a-bottom sticky-header bg-white" [ngStyle]="responsiveHeaderWidthGrid(cl)">
                          <ng-container *ngFor="let ql of cl.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} optionImg" (play)="playVideo(ql, a, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="optionImg" />
                            </div>
                          </ng-container>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="
                          let gridm of surveyDetail.rowOptionList;
                          let last = last;
                          let k = index
                        " class="checkRowMultiple{{ k }}">
                        <td class="v-a-middle sticky-col first-col">
                          <ng-container *ngFor="let ql of gridm.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} optionImg" (play)="playVideo(ql, k, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="optionImg" />
                            </div>
                          </ng-container>
                          <div *ngIf="gridm.other == 1" style="display: inline-block; margin-left: 20px">
                            <input type="text" style="width: 70%" class="form-control" id="{{ gridm.var }}_other" />
                          </div>
                        </td>
                        <td *ngFor="
                            let cl of surveyDetail.colOptionList;
                            let j = index
                          " class="input_cell" [ngStyle]="responsiveWidthGrid()">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" (change)="rowMultiSelect($event, gridm, cl)" class="desk_{{
                                gridm.var
                              }} custom-control-input gridCheckMultipleDesk col_var_{{
                                cl.var
                              }} colRow{{ gridm.optionCode }}" id="{{ surveyDetail.qID }}_r{{
                                gridm.optionCode
                              }}_c{{ cl.optionCode }}" attr.sendId="{{ surveyDetail.qID }}_r{{
                                gridm.optionCode
                              }}_c{{ cl.optionCode }}" name="{{ gridm.var }}" value="{{ gridm.other }}"
                              attr.colOther="{{ cl.other }}" attr.rowOther="{{ gridm.other }}"
                              attr.colVar="{{ cl.var }}" attr.rowVar="{{ gridm.var }}"
                              attr.rowexclusive="{{ cl.exclusive }}" />
                            <label class="custom-control-label cursor-pointer" for="{{ surveyDetail.qID }}_r{{
                                gridm.optionCode
                              }}_c{{ cl.optionCode }}">
                            </label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-lg-12 showGrid">
                <mat-accordion *ngFor="
                    let gridm of surveyDetail.rowOptionList;
                    let k = index;
                    let last = last
                  " class="checkRowMultiple{{ k }}">
                  <mat-expansion-panel class="p-1" [expanded]="k == 0">
                    <mat-expansion-panel-header class="pl-0">
                      <mat-panel-title>
                        <div class="col-lg-12">
                          <ng-container *ngFor="let ql of gridm.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} concept_video1" (play)="playVideo(ql, k, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="concept_video1" />
                            </div>
                          </ng-container>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="p-2">
                      <div *ngIf="gridm.other == 1" class="ml-2 mb-2">
                        <input type="text" style="height: 25px" class="form-control" id="{{ gridm.var }}_other_mob" />
                      </div>

                      <div *ngFor="
                          let cl of surveyDetail.colOptionList;
                          let j = index
                        ">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" (change)="rowMultiSelect($event, gridm, cl)" class="mob_{{
                              gridm.var
                            }} custom-control-input rowUnchecked col_var_{{
                              cl.var
                            }} colRow{{ gridm.optionCode }}" id="mob_{{ surveyDetail.qID }}_r{{
                              gridm.optionCode
                            }}_c{{ cl.optionCode }}" attr.sendId="{{ surveyDetail.qID }}_r{{
                              gridm.optionCode
                            }}_c{{ cl.optionCode }}" name="{{ gridm.var }}" value="{{ gridm.other }}"
                            attr.colOther="{{ cl.other }}" attr.rowOther="{{ gridm.other }}" attr.colVar="{{ cl.var }}"
                            attr.rowVar="{{ gridm.var }}" attr.rowexclusive="{{ cl.exclusive }}" />
                          <label class="custom-control-label cursor-pointer" for="mob_{{ surveyDetail.qID }}_r{{
                              gridm.optionCode
                            }}_c{{ cl.optionCode }}">
                            <ng-container *ngFor="let ql of cl.optionText">
                              <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                              </span>
                              <div *ngIf="ql.type == 'video'">
                                <video class="video-full{{ ql.id }} concept_video1" (play)="playVideo(ql, k, last)"
                                  max-width="100%" max-height="100%" controls controlsList="nodownload"
                                  id="con_val_op{{ ql.id }}">
                                  <source src="{{ ql.detail }}" type="video/mp4" />
                                  Your browser does not support video, please
                                  change your browser.
                                </video>
                              </div>
                              <div *ngIf="ql.type == 'image'">
                                <img src="{{ ql.detail }}" class="concept_video1" />
                              </div>
                            </ng-container>
                          </label>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'grid-column-multiple-select'" class="scroll-wrapper">
              <div class="table-scroll-container">
                <div class="scrollbar-top" id="scrollTop" #scrollTop (scroll)="syncScroll('top')">
                  <div [style.width]="topScrollWidth"></div>
                </div>
                <div class="table-scroll-wrapper table-responsive" id="scrollBottom" #scrollBottom
                  (scroll)="syncScroll('bottom')">
                  <table class="table table-bordered table-resp showOrNot freeze-table grid_table"
                    [ngStyle]="{ 'min-width': tableMinWidth }">
                    <thead>
                      <tr>
                        <th class="sticky-col first-col bg-white z-index-2"></th>
                        <th *ngFor="
                            let cl of surveyDetail.colOptionList;
                            let last = last;
                            let a = index
                          " class="text-center v-a-bottom sticky-header bg-white" [ngStyle]="responsiveHeaderWidthGrid(cl)">
                          <ng-container *ngFor="let ql of cl.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} optionImg" (play)="playVideo(ql, a, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="optionImg" />
                            </div>
                          </ng-container>
                          <div *ngIf="cl.other == 1" style="display: inline-block; margin-left: 20px">
                            <input type="text" style="width: 70%" class="form-control" id="{{ cl.var }}_other" />
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="
                          let gridm of surveyDetail.rowOptionList;
                          let last = last;
                          let k = index
                        ">
                        <td style="width: 25%" class="v-a-middle sticky-col first-col">
                          <ng-container *ngFor="let ql of gridm.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} optionImg" (play)="playVideo(ql, k, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="optionImg" />
                            </div>
                          </ng-container>
                        </td>
                        <td *ngFor="
                            let cl of surveyDetail.colOptionList;
                            let j = index
                          " class="input_cell checkColMultiple{{ j }}" [ngStyle]="responsiveWidthGrid()">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" (change)="colMultiSelect($event, gridm, cl)" class="custom-control-input desk_col{{
                                cl.var
                              }} gridCheckMultipleColDesk grid_Var_{{
                                gridm.var
                              }} colLen{{ cl.optionCode }}" attr.sendId="{{ surveyDetail.qID }}_r{{
                                gridm.optionCode
                              }}_c{{ cl.optionCode }}" id="{{ surveyDetail.qID }}_r{{
                                gridm.optionCode
                              }}_c{{ cl.optionCode }}" name="{{ cl.var }}" value="{{ cl.other }}"
                              attr.colOther="{{ cl.other }}" attr.rowOther="{{ gridm.other }}"
                              attr.colVar="{{ cl.var }}" attr.rowVar="{{ gridm.var }}"
                              attr.dataexclusive="{{ gridm.exclusive }}" />
                            <label class="custom-control-label cursor-pointer" for="{{ surveyDetail.qID }}_r{{
                                gridm.optionCode
                              }}_c{{ cl.optionCode }}"></label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-lg-12 showGrid">
                <mat-accordion *ngFor="
                    let cl of surveyDetail.colOptionList;
                    let k = index;
                    let last = last
                  " class="checkRowMultiple{{ k }}">
                  <mat-expansion-panel class="p-1" [expanded]="k == 0">
                    <mat-expansion-panel-header class="pl-0">
                      <mat-panel-title>
                        <div class="col-lg-12">
                          <ng-container *ngFor="let ql of cl.optionText">
                            <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} concept_video1" (play)="playVideo(ql, k, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="concept_video1" />
                            </div>
                          </ng-container>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="p-2">
                      <div *ngIf="cl.other == 1" class="ml-2 mb-2">
                        <input type="text" style="height: 25px" class="form-control" id="{{ cl.var }}_other_mob" />
                      </div>
                      <div *ngFor="
                          let gridm of surveyDetail.rowOptionList;
                          let j = index;
                          let last = last
                        ">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" (change)="colMultiSelect($event, gridm, cl)" class="custom-control-input mob_col{{
                              cl.var
                            }} uncheckedData grid_Var_{{ gridm.var }} colLen{{
                              cl.optionCode
                            }}" attr.sendId="{{ surveyDetail.qID }}_r{{
                              gridm.optionCode
                            }}_c{{ cl.optionCode }}" id="mob_col_{{ surveyDetail.qID }}_r{{
                              gridm.optionCode
                            }}_c{{ cl.optionCode }}" name="{{ cl.var }}" value="{{ cl.other }}"
                            attr.colOther="{{ cl.other }}" attr.rowOther="{{ gridm.other }}" attr.colVar="{{ cl.var }}"
                            attr.rowVar="{{ gridm.var }}" attr.dataexclusive="{{ gridm.exclusive }}" />
                          <label class="custom-control-label cursor-pointer" for="mob_col_{{ surveyDetail.qID }}_r{{
                              gridm.optionCode
                            }}_c{{ cl.optionCode }}">
                            <ng-container *ngFor="let ql of gridm.optionText">
                              <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                              </span>
                              <div *ngIf="ql.type == 'video'">
                                <video class="video-full{{ ql.id }} concept_video1" (play)="playVideo(ql, j, last)"
                                  max-width="100%" max-height="100%" controls controlsList="nodownload"
                                  id="con_val_op{{ ql.id }}">
                                  <source src="{{ ql.detail }}" type="video/mp4" />
                                  Your browser does not support video, please
                                  change your browser.
                                </video>
                              </div>
                              <div *ngIf="ql.type == 'image'">
                                <img src="{{ ql.detail }}" class="concept_video1" />
                              </div>
                            </ng-container>
                          </label>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'drag-n-drop-ranking'">
              <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event, surveyDetail)"
                *ngIf="show == 'show' || show == ''">
                <div class="example-box" *ngFor="
                    let drag of surveyDetail.rowOptionList;
                    let last = last;
                    let i = index
                  " cdkDrag>
                  <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                  <span class="badge" *ngIf="show == 'show'">{{ i + 1 }}</span>&nbsp;
                  <ng-container *ngFor="let ql of drag.optionText">
                    <span *ngIf="ql.type == 'string'" class="d-in rank_ques" [innerHTML]="ql.detail | safe : 'html'">
                    </span>
                    <div *ngIf="ql.type == 'video'">
                      <video class="video-full{{ ql.id }} optionImgMulti" (play)="playVideo(ql, i, last)"
                        max-width="100%" max-height="100%" controls controlsList="nodownload"
                        id="con_val_op{{ ql.id }}">
                        <source src="{{ ql.detail }}" type="video/mp4" />
                        Your browser does not support video, please change your
                        browser.
                      </video>
                    </div>
                    <div *ngIf="ql.type == 'image'">
                      <img src="{{ ql.detail }}" class="optionImgMulti" />
                    </div>
                  </ng-container>
                  <input *ngIf="show == 'show'" type="hidden" value="{{ i + 1 }}" id="{{ drag.var }}" />
                </div>
              </div>

              <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event, surveyDetail)"
                *ngIf="show == 'set' && show != ''">
                <div class="example-box" *ngFor="
                    let drag of finalDropArr;
                    let last = last;
                    let i = index
                  " cdkDrag>
                  <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                  <span class="badge">{{ drag.optionVal }}</span>&nbsp;
                  <ng-container *ngFor="let ql of drag.optionText">
                    <span *ngIf="ql.type == 'string'" class="d-in rank_ques" [innerHTML]="ql.detail | safe : 'html'">
                    </span>
                    <div *ngIf="ql.type == 'video'">
                      <video class="video-full{{ ql.id }} optionImgMulti" (play)="playVideo(ql, i, last)"
                        max-width="100%" max-height="100%" controls controlsList="nodownload"
                        id="con_val_op{{ ql.id }}">
                        <source src="{{ ql.detail }}" type="video/mp4" />
                        Your browser does not support video, please change your
                        browser.
                      </video>
                    </div>
                    <div *ngIf="ql.type == 'image'">
                      <img src="{{ ql.detail }}" class="optionImgMulti" />
                    </div>
                  </ng-container>
                  <input *ngIf="show == 'show'" type="hidden" value="{{ drag.optionVal }}" id="{{ drag.var }}" />
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'ranking'">
              <div *ngFor="
                  let list of surveyDetail.rowOptionList;
                  let last = last;
                  let i = index
                ">
                <div class="row mt-2">
                  <div class="col-lg-1" *ngIf="list.exclusive == 0">
                    <input type="number" min="{{ numericMin }}" max="{{ numericMax }}" (keyup)="
                        checkValue($event, list, surveyDetail.rowOptionList)
                      " name="{{ list.exclusive }}" attr.dataType="{{ list.other }}" class="form-control getAllRank"
                      id="{{ list.var }}" style="max-width: 100px" />
                  </div>
                  <div class="col-lg-1 text-center" *ngIf="list.exclusive == 1">
                    <div class="custom-control custom-checkbox mt-1">
                      <input type="checkbox" class="custom-control-input rankExcl" id="rank_{{ list.var }}"
                        name="{{ list.exclusive }}" value="{{ list.var }}" (change)="rankSr($event)" />
                      <label class="custom-control-label cursor-pointer" for="rank_{{ list.var }}">
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-10">
                    <ng-container *ngFor="let ql of list.optionText">
                      <span *ngIf="ql.type == 'string'" class="rank_ques" [innerHTML]="ql.detail | safe : 'html'">
                      </span>
                      <div *ngIf="ql.type == 'video'">
                        <video class="video-full{{ ql.id }} optionImgMulti" (play)="playVideo(ql, i, last)"
                          max-width="100%" max-height="100%" controls controlsList="nodownload"
                          id="con_val_op{{ ql.id }}">
                          <source src="{{ ql.detail }}" type="video/mp4" />
                          Your browser does not support video, please change
                          your browser.
                        </video>
                      </div>
                      <div *ngIf="ql.type == 'image'">
                        <img src="{{ ql.detail }}" class="optionImgMulti" />
                      </div>
                    </ng-container>
                    <div *ngIf="list.other == 1" class="d-inline-block ml-3">
                      <input type="text" style="width: 70%" class="form-control" id="{{ list.var }}_other"
                        (keyup)="othRank($event)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'sum-upto-n'">
              <div *ngFor="
                  let list of surveyDetail.rowOptionList;
                  let i = index;
                  let last = last
                ">
                <div class="row mt-2">
                  <div class="col-lg-1 col-sm-2 col-md-2 pr-0" *ngIf="list.exclusive == 0">
                    <input type="number" min="{{ numericMin }}" max="{{ numericMax }}" class="form-control sumAll"
                      id="sumUp{{ list.var }}" (keyup)="survey($event, list)" style="max-width: 100px" />
                  </div>
                  <div class="col-lg-1 col-sm-2 text-center col-md-2 pr-0" *ngIf="list.exclusive == 1">
                    <div class="custom-control custom-checkbox mt-1">
                      <input type="checkbox" class="custom-control-input getAllExcl" id="list_{{ list.var }}"
                        value="{{ list.exclusive }}" attr.dataother="{{ list.var }}" name="{{ list.other }}"
                        (change)="sumUpTo($event)" />
                      <label class="custom-control-label cursor-pointer" for="list_{{ list.var }}"></label>
                    </div>
                  </div>

                  <div class="col-lg-10">
                    <ng-container *ngFor="let ql of list.optionText">
                      <span *ngIf="ql.type == 'string'" class="rank_ques" [innerHTML]="ql.detail | safe : 'html'">
                      </span>
                      <div *ngIf="ql.type == 'video'">
                        <video class="video-full{{ ql.id }} optionImgMulti" (play)="playVideo(ql, i, last)"
                          max-width="100%" max-height="100%" controls controlsList="nodownload"
                          id="con_val_op{{ ql.id }}">
                          <source src="{{ ql.detail }}" type="video/mp4" />
                          Your browser does not support video, please change
                          your browser.
                        </video>
                      </div>
                      <div *ngIf="ql.type == 'image'">
                        <img src="{{ ql.detail }}" class="optionImgMulti" />
                      </div>
                    </ng-container>
                    <div *ngIf="list.other == 1" class="d-inline-block ml-3">
                      <input type="text" style="width: 70%" class="form-control" id="{{ list.var }}_other"
                        (keyup)="sumOth($event)" />
                    </div>
                  </div>
                </div>
                <div class="row mt-2" *ngIf="last == true">
                  <div class="col-lg-1 col-sm-2 col-md-2 pr-0">
                    <input type="text" class="form-control" id="totalData" disabled style="max-width: 100px" />
                  </div>
                  <div class="col-lg-10 col-sm-10 col-md-10">
                    <span class="rank_ques">
                      <p>Total</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'single-select-horizontal-grid'">
              <div class="t-center">
                <div class="col-lg-12 ml-4 mt-3 show_desk">
                  <div class="row">
                    <div *ngFor="
                        let cl of surveyDetail.rowOptionList;
                        let last = last;
                        let i = index
                      " [ngStyle]="responsiveWidthCarusole()" class="ml-2">
                      <input type="radio" class="button horizontalCheck" id="horzi{{ i }}" value="{{ cl.optionCode }}"
                        name="check" />
                      <label for="horzi{{ i }}" class="custom-label cursor-pointer box_input"
                        [ngStyle]="{ background: nextButton, color: accent }">
                        <ng-container *ngFor="let ql of cl.optionText">
                          <span *ngIf="ql.type == 'string'" class="text-white" [innerHTML]="ql.detail | safe : 'html'">
                          </span>
                          <div *ngIf="ql.type == 'video'">
                            <video class="video-full{{ ql.id }} optionImg" (play)="playVideo(ql, i, last)" width="100%"
                              max-height="100%" controls controlsList="nodownload" id="con_val_op{{ ql.id }}">
                              <source src="{{ ql.detail }}" type="video/mp4" />
                              Your browser does not support video, please change
                              your browser.
                            </video>
                          </div>
                          <div *ngIf="ql.type == 'image'">
                            <img src="{{ ql.detail }}" class="optionImg" />
                          </div>
                        </ng-container>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Mobile view -->
              <div class="row show_mob">
                <div class="col-lg-12">
                  <div class="custom-control custom-radio" *ngFor="
                      let cl of surveyDetail.rowOptionList;
                      let last = last;
                      let i = index
                    ">
                    <input type="radio" class="custom-control-input horizontalCheck" id="horziMob{{ i }}"
                      value="{{ cl.optionCode }}" name="check" />
                    <label class="custom-control-label" for="horziMob{{ i }}">
                      <ng-container *ngFor="let ql of cl.optionText">
                        <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                        </span>
                        <div *ngIf="ql.type == 'video'">
                          <video class="video-full{{ ql.id }} concept_video1" (play)="playVideo(ql, i, last)"
                            max-width="100%" max-height="100%" controls controlsList="nodownload"
                            id="con_val_op{{ ql.id }}">
                            <source src="{{ ql.detail }}" type="video/mp4" />
                            Your browser does not support video, please change
                            your browser.
                          </video>
                        </div>
                        <div *ngIf="ql.type == 'image'">
                          <img src="{{ ql.detail }}" class="concept_video1" />
                        </div>
                      </ng-container>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'numeric-row-list'">
              <div *ngFor="
                  let list of surveyDetail.rowOptionList;
                  let i = index;
                  let last = last
                ">
                <div class="row mt-2">
                  <div class="col-lg-2 spinrm" *ngIf="list.exclusive == 0">
                    <input type="number" min="{{ numericMin }}" max="{{ numericMax }}"
                      class="form-control resp-num-list getAllNumvalue" value="{{ list.default }}"
                      attr.var="{{ list.var }}" attr.dataother="{{ list.other }}"
                      attr.dataexclusive="{{ list.exclusive }}" name="{{ list.var }}" id="numUp{{ list.var }}"
                      style="max-width: 100px" />
                  </div>
                  <div class="col-lg-2 ct-resp" *ngIf="list.exclusive == 1">
                    <div class="custom-control custom-checkbox mt-1">
                      <input type="checkbox" class="custom-control-input numCheck" id="num{{ i }}"
                        attr.var="{{ list.var }}" value="{{ list.var }}" attr.dataexclusive="{{ list.exclusive }}"
                        attr.dataother="{{ list.other }}" name="{{ list.other }}" (change)="numSr($event)" />
                      <label class="custom-control-label cursor-pointer" for="num{{ i }}">
                      </label>
                    </div>
                  </div>

                  <div class="col-lg-10">
                    <ng-container *ngFor="let ql of list.optionText">
                      <span *ngIf="ql.type == 'string'" class="rank_ques" [innerHTML]="ql.detail | safe : 'html'">
                      </span>
                      <div *ngIf="ql.type == 'video'">
                        <video class="video-full{{ ql.id }} optionImgMulti" (play)="playVideo(ql, i, last)"
                          max-width="100%" max-height="100%" controls controlsList="nodownload"
                          id="con_val_op{{ ql.id }}">
                          <source src="{{ ql.detail }}" type="video/mp4" />
                          Your browser does not support video, please change
                          your browser.
                        </video>
                      </div>
                      <div *ngIf="ql.type == 'image'">
                        <img src="{{ ql.detail }}" class="optionImgMulti" />
                      </div>
                    </ng-container>
                    <div *ngIf="list.other == 1" class="d-inline-block ml-3">
                      <input type="text" style="width: 70%" class="form-control" id="{{ list.var }}_other"
                        name="ot{{ i }}" (keyup)="numOth($event)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'percentage-row-list'">
              <div *ngFor="
                  let text of surveyDetail?.rowOptionList;
                  let last = last;
                  let i = index
                ">
                <div class="row mt-2">
                  <div class="col-lg-2 spinrm d-inline-block" *ngIf="text.exclusive == 0">
                    <input type="number" min="0" max="100" id="{{ text.var }}"
                      class="form-control h-35 getAllPervalue d-inline-block" style="max-width: 100px" />
                    <div class="mt-1 d-inline-block text-left" *ngIf="text.exclusive == 0">
                      &nbsp; %
                    </div>
                  </div>
                  <div class="col-lg-2 ct-resp" *ngIf="text.exclusive == 1">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input getAllPerCheck" id="per_{{ text.var }}"
                        value="{{ text.var }}" name="{{ text.other }}" (change)="perSr($event)" />
                      <label class="custom-control-label cursor-pointer" for="per_{{ text.var }}">
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-10">
                    <ng-container *ngFor="let ql of text.optionText">
                      <span *ngIf="ql.type == 'string'" class="d-inline-block" [innerHTML]="ql.detail | safe : 'html'">
                      </span>
                      <div *ngIf="ql.type == 'video'">
                        <video class="video-full{{ ql.id }} optionImgMulti" (play)="playVideo(ql, i, last)"
                          max-width="100%" max-height="100%" controls controlsList="nodownload"
                          id="con_val_op{{ ql.id }}">
                          <source src="{{ ql.detail }}" type="video/mp4" />
                          Your browser does not support video, please change
                          your browser.
                        </video>
                      </div>
                      <div *ngIf="ql.type == 'image'">
                        <img src="{{ ql.detail }}" class="optionImgMulti" />
                      </div>
                    </ng-container>
                    <div *ngIf="text.other == 1" class="d-inline-block ml-3">
                      <input type="text" value="" id="oth_{{ text.var }}" class="form-control h-35 getAllPervalue"
                        (keyup)="perOther($event)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType == 'drag-n-drop-ranking-column'">
              <div class="row dragNDrop mt-2">
                <div class="col-6 col-lg-6">
                  <span class="text-center">Statements Box</span>
                  <div class="drag-container-dual">
                    <div cdkDropList #todoList="cdkDropList" (cdkDropListDropped)="dropDual($event)"
                      [cdkDropListConnectedTo]="[doneList]" class="drag-list-dual" [cdkDropListData]="mainDropArr">
                      <div class="drag-box-dual" *ngFor="
                          let item of mainDropArr;
                          let last = last;
                          let i = index
                        " cdkDrag>
                        <ng-container *ngFor="let ql of item.optionText">
                          <span *ngIf="ql.type == 'string'" [innerHTML]="ql.detail | safe : 'html'">
                          </span>
                          <div *ngIf="ql.type == 'video'">
                            <video class="video-full{{ ql.id }} optionImgMulti" (play)="playVideo(ql, i, last)"
                              max-width="100%" max-height="100%" controls controlsList="nodownload"
                              id="con_val_op{{ ql.id }}">
                              <source src="{{ ql.detail }}" type="video/mp4" />
                              Your browser does not support video, please change
                              your browser.
                            </video>
                          </div>
                          <div *ngIf="ql.type == 'image'">
                            <img src="{{ ql.detail }}" class="optionImgMulti" />
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-lg-6">
                  <span class="text-center">Ranking Box</span>
                  <div class="drag-container-dual">
                    <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="responseArr"
                      [cdkDropListConnectedTo]="[todoList]" class="drag-list-dual"
                      (cdkDropListDropped)="dropDual($event)">
                      <div class="drag-box-dual" *ngFor="
                          let item of responseArr;
                          let last = last;
                          let i = index
                        " cdkDrag>
                        <div class="d-inline-block">
                          <span class="badge">{{ i + 1 }}</span>
                          <ng-container *ngFor="let ql of item.optionText">
                            <span class="d-inline-block ml-3" *ngIf="ql.type == 'string'"
                              [innerHTML]="ql.detail | safe : 'html'">
                            </span>
                            <div *ngIf="ql.type == 'video'">
                              <video class="video-full{{ ql.id }} optionImgMulti" (play)="playVideo(ql, i, last)"
                                max-width="100%" max-height="100%" controls controlsList="nodownload"
                                id="con_val_op{{ ql.id }}">
                                <source src="{{ ql.detail }}" type="video/mp4" />
                                Your browser does not support video, please
                                change your browser.
                              </video>
                            </div>
                            <div *ngIf="ql.type == 'image'">
                              <img src="{{ ql.detail }}" class="optionImgMulti" />
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="
                surveyDetail?.qType == 'audio-question' ||
                surveyDetail?.qType == 'video-question'
              ">
              <app-recorder [surveyDetail]="surveyDetail" [setData]="setData" [nextButton]="nextButton"
                [resetRecordingVar]="resetRecordingVar" [stopRecordingVar]="stopRecordingVar"
                (recordingCompleted)="onRecordingCompleted($event)" (recordedUrl)="recorderBlobFn($event)"
                (ResetOff)="ResetOffFn($event)" (stopRecord)="stopRecordFn($event)">
              </app-recorder>
              <div class="row mt-2" *ngIf="surveyDetail?.ri">
                <div class="col-lg-12">
                  <label class="text-center font-weight-bold font-italic text-secondary">Maximum duration for this
                    recording is
                    {{surveyDetail?.["MAX-SELECTION"]/60}} minute(s).</label>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType?.toLowerCase() == 'text-highlighter'">
              <div class="">
                <div class="d-flex justify-content-between align-items-center px-0 py-2 sentiment_mobile gap_10">
                  <!-- desktop view -->
                  <div class="gap_10 d-none d-md-flex w-100">
                    <div class="d-flex justify-content-between w-100">
                      <div class="d-flex">
                        <div *ngFor="let sentiment of surveyDetail?.rowOptionList" class="sentiment-chip" [ngStyle]="{
    'background-color': sentiment?.optionLogic,
    'border': surveyDetail?.selectedSentiment === sentiment?.optionLogic ? '2px solid black' : '2px solid transparent'
  }" (click)="selectSentiment(sentiment)">
                          {{ sentiment?.optionText }}
                        </div>
                      </div>
                      <div class="reset-chip" (click)="clearHighlights()" title="Clear all highlights" [ngStyle]="{
    'border-color': nextButton,
    'color': nextButton
  }">
                        <i class="fa fa-refresh"></i>
                        <span>Reset</span>
                      </div>
                    </div>
                  </div>

                  <!-- mobile view -->
                  <div class="d-block d-md-none sentiment_dropdown w-100">
                    <div class="d-flex justify-content-between align-items-center w-100 gap_10">
                      <div class="sentiment_dropdown_left" id="mobile_highlighter_dropdown"
                        (click)="sentimentDropdown()" [class.open]="surveyDetail?.isSentimentOpen">
                        <div class="selected-option text-white d-flex align-items-center"
                          [style.background-color]="surveyDetail?.selectedSentiment">
                          <span class="selected-text text-truncate">
                            {{ surveyDetail?.selectedSentimentMobile?.optionText }}
                          </span>
                          <i class="fa fa-chevron-down dropdown-icon ms-2"
                            [ngClass]="{'rotate': surveyDetail?.isSentimentOpen}">
                          </i>
                        </div>

                        <div class="options d-flex flex-column" id="mobile_highlighter_dropdown_option"
                          *ngIf="surveyDetail?.rowOptionList?.length > 1 && surveyDetail?.isSentimentOpen">

                          <div *ngFor="let sentiment of surveyDetail?.rowOptionList" class="d-flex py-2 px-3"
                            [ngClass]="{'selected_option': surveyDetail?.selectedSentiment == sentiment?.optionLogic}"
                            (click)="selectSentiment(sentiment)">

                            <div class="d-flex align-items-center gap_8 mobile_sentiment option_hover">
                              <span class="color-dot" [ngStyle]="{'background-color': sentiment?.optionLogic}">
                              </span>
                              <span>{{ sentiment.optionText }}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="reset-chip" (click)="clearHighlights()" title="Clear all highlights" [ngStyle]="{
    'border-color': nextButton,
    'color': nextButton
  }">
                        <i class="fa fa-refresh"></i>
                        <span>Reset</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="highlight-text highlighter_border" (mouseup)="highlightSelection()">
                  <p *ngFor="let para of surveyDetail?.paragraph; let i = index"
                    class="d-block paragraph-container text_para">
                    <ng-container *ngIf="para?.length == 0">
                      <br>
                    </ng-container>
                    <ng-container *ngIf="para?.length > 0">
                      <span *ngFor="let word of para; let j = index" class="word cursor-pointer word_space word_format"
                        id="{{word?.id}}" style.backgroundColor="{{word?.sentiment}}"
                        [ngClass]="{'text-white': word?.sentiment && word?.sentiment != ''}"
                        (click)="toggleWord(word, $event)">{{word.text}}</span>
                    </ng-container>
                  </p>
                </div>
              </div>
            </div>

            <div *ngIf="surveyDetail?.qType?.toLowerCase() == 'image-heatmap'">
              <div>
                <div class="d-flex justify-content-between align-items-center py-2 sentiment_mobile gap_10">
                  <!-- desktop view -->
                  <div class="d-none d-md-flex w-100">
                    <div class="d-flex justify-content-around w-100">
                      <div class="d-flex w-100">
                        <div *ngFor="let sentiment of surveyDetail?.rowOptionList"
                          class="sentiment-chip d-flex align-items-center gap_8" [ngStyle]="{
    'background-color': sentiment?.optionLogic,
    'border': surveyDetail?.selectedSentiment === sentiment?.optionLogic ? '2px solid black' : '2px solid transparent'
  }" (click)="selectSentiment(sentiment)">
                          <span class="heatmap_sentiment_text">
                            {{ sentiment?.optionText }}
                          </span>
                        </div>
                      </div>
                      <div class="reset-chip" (click)="clearHeatmapMakrker()" title="Clear all" [ngStyle]="{
    'border-color': nextButton,
    'color': nextButton
  }">
                        <i class="fa fa-refresh"></i>
                        <span>Reset</span>
                      </div>
                    </div>
                  </div>

                  <!-- mobile view -->
                  <div class="d-block d-md-none sentiment_dropdown w-100">
                    <div class="d-flex justify-content-between align-items-center w-100 gap_10">
                      <div class="sentiment_dropdown_left" id="mobile_heatmap_dropdown" (click)="sentimentDropdown()"
                        [class.open]="surveyDetail?.isSentimentOpen">
                        <div class="selected-option text-white d-flex align-items-center"
                          [style.background-color]="surveyDetail?.selectedSentiment">
                          <span class="selected-text text-truncate">
                            {{ surveyDetail?.selectedSentimentMobile?.optionText }}
                          </span>
                          <i class="fa fa-chevron-down dropdown-icon ms-2"
                            [ngClass]="{'rotate': surveyDetail?.isSentimentOpen}">
                          </i>
                        </div>

                        <div *ngIf="surveyDetail?.rowOptionList?.length > 1 && surveyDetail?.isSentimentOpen"
                          class="options d-flex flex-column" id="mobile_heatmap_dropdown_option">
                          <div *ngFor="let sentiment of surveyDetail?.rowOptionList; let i = index"
                            class="d-flex py-2 px-3"
                            [ngClass]="{'selected_option': surveyDetail?.selectedSentiment == sentiment?.optionLogic, 'top_heatmap_option': i == 0}"
                            (click)="selectSentiment(sentiment)">
                            <div class="d-flex align-items-center gap_8 mobile_sentiment option_hover">
                              <span class="sentiment_dot"
                                [ngStyle]="{'background-color': sentiment?.optionLogic}"></span>
                              <span>{{ sentiment.optionText }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="reset-chip" (click)="clearHeatmapMakrker()" title="Clear all" [ngStyle]="{
    'border-color': nextButton,
    'color': nextButton
  }">
                        <i class="fa fa-refresh"></i>
                        <span>Reset</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="heatmap_img highlighter_border text-center">
                  <div class="image-container" (click)="markImageHeatmap($event)">
                    <div class="image-wrapper">
                      <img src="{{surveyDetail?.image_location}}" alt="image to mark" class="cursor_crosshair" />
                      <!-- Overlay points -->
                      <div *ngFor="let point of surveyDetail?.clickPoint" class="click-point cursor_pointer"
                        id="marker__{{point.xPercent}}_{{point.yPercent}}" [style.left.%]="point.xPercent"
                        [style.top.%]="point.yPercent" [style.background-color]="point?.sentiment"
                        [style.box-shadow]="'0 0 10px 4px ' + point?.sentiment"
                        [title]="surveyDetail?.selectedSentiment == point?.sentiment ? 'Remove' : ''"
                        (click)="$event.stopPropagation(); removeHeatmapPoint(point)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6 col-lg-6 mt-4">
            <ng-container *ngIf="surveyDetail.qType != 'max-diff'">
              <button class="btn btn_previous" *ngIf="prevQuestion != '' && !hideBackButton"
                (click)="previousQuestion()" [ngStyle]="{ background: backButton }">
                <i class="fa fa-angle-left fnt_1"></i> &nbsp;Back
              </button>
            </ng-container>
            <ng-container *ngIf="surveyDetail.qType == 'max-diff'">
              <button class="btn btn_previous" *ngIf="showPopup == false && !hideBackButton" (click)="previousSet()"
                [ngStyle]="{ background: backButton }">
                <i class="fa fa-angle-left fnt_1"></i> &nbsp;Back
              </button>
            </ng-container>
          </div>

          <div class="col-6 col-lg-6 text-right mt-4">
            <!-- Button controls for grid carusole question -->
            <ng-container *ngIf="surveyDetail?.qType == 'grid-row-single-select-carousel'">
              <button class="btn btn_previous ml-3 not-btn" *ngIf="
                  arrlength != rowList && (videoPlayed == 0 || videoPlayed == 1)
                " [ngStyle]="{ background: nextButton }">
                Next &nbsp;<i class="fa fa-angle-right fnt_1"></i>
              </button>
              <button class="btn btn_previous ml-3" (click)="saveSurvey()" *ngIf="
                  arrlength == rowList &&
                  totalVideo.length == 0 &&
                  videoPlayed == 0
                " [ngStyle]="{ background: nextButton }">
                Next &nbsp;<i class="fa fa-angle-right fnt_1"></i>
              </button>
              <button class="btn btn_previous ml-3" (click)="saveSurvey()" *ngIf="
                  arrlength == rowList &&
                  totalVideo.length > 0 &&
                  videoPlayed == 1
                " [ngStyle]="{ background: nextButton }">
                Next &nbsp;<i class="fa fa-angle-right fnt_1"></i>
              </button>
            </ng-container>

            <!-- Button Control for non carusole -->
            <ng-container *ngIf="
                surveyDetail?.qType != 'grid-row-single-select-carousel' &&
                surveyDetail.qType != 'max-diff' &&
                surveyDetail?.qType != 'audio-question' &&
                surveyDetail?.qType != 'video-question' 
              ">
              <button class="btn btn_previous ml-3 not-btn" *ngIf="
                  (surveyDetail.hasVideo == 1 || totalVideo.length > 0) &&
                  videoPlayed == 0
                " [ngStyle]="{ background: nextButton }">
                Next &nbsp;<i class="fa fa-angle-right fnt_1"></i>
              </button>
              <button class="btn btn_previous ml-3" (click)="saveSurvey()" *ngIf="
                  (surveyDetail.hasVideo == 0 || totalVideo.length > 0) &&
                  videoPlayed == 1
                " [ngStyle]="{ background: nextButton }">
                Next &nbsp;<i class="fa fa-angle-right fnt_1"></i>
              </button>
              <button class="btn btn_previous ml-3" (click)="saveSurvey()" *ngIf="
                  surveyDetail?.hasVideo == 0 &&
                  videoPlayed == 0 &&
                  totalVideo.length == 0
                " [ngStyle]="{ background: nextButton }">
                Next &nbsp;<i class="fa fa-angle-right fnt_1"></i>
              </button>
            </ng-container>
            <ng-container *ngIf="
                surveyDetail.qType == 'max-diff' &&
                surveyDetail?.qType != 'audio-question' &&
                surveyDetail?.qType != 'video-question'
              ">
              <button class="btn btn_previous ml-3" *ngIf="showPopup == false" [ngStyle]="{ background: nextButton }"
                (click)="nextSet()">
                Next &nbsp;<i class="fa fa-angle-right fnt_1"></i>
              </button>
            </ng-container>
            <ng-container *ngIf="
                surveyDetail.qType != 'max-diff' &&
                (surveyDetail?.qType == 'audio-question' ||
                  surveyDetail?.qType == 'video-question')
              ">
              <button class="btn btn_previous ml-3" *ngIf="showPopup == false" [ngStyle]="{ background: nextButton }"
                (click)="audioVideoRecorderNext()">
                Next &nbsp;<i class="fa fa-angle-right fnt_1"></i>
              </button>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="col-lg-1"></div>
    </div>

  </div>
  <div class="powered-by-section">
    <a href="https://www.insightscurry.com/sign-up/" target="_blank" rel="noopener noreferrer" class="powered-by-link">
      <span class="powered-text">⚡ Powered by</span>
      <span class="brand-name">Insights Curry</span>
    </a>
  </div>

  <!-- Survey End -->

  <!-- Catlina auth process -->
  <div class="container survey-container" [ngStyle]="deskWidth" *ngIf="
      identify?.identification == 'external' && identify?.provider == 'catalina'
    ">
    <div class="row">
      <div class="col-lg-12 mt-2 mb-5 m-p">
        <div class="card">
          <div class="card-body">
            <div id="header"></div>
            <div class="row">
              <div class="col-lg-12">
                <h5 class="d-inline-block w-100">
                  <span class="d-inline-block w-100">Please enter your 13 or 14 digit personal PIN # (including
                    the three dashes) that is located at the bottom of your
                    coupon under Step 2 instructions.
                  </span>
                </h5>
                <p class="mt-3">(Enter like this: 1-123-1234-12345)</p>
              </div>
            </div>
            <div class="row mt-3 mb-5">
              <div class="col-3">PIN:</div>
              <div class="col-9">
                <div class="form-group">
                  <input type="text" class="form-control text-center catlina-wd" id="catVal" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 text-right mt-4">
          <button class="btn btn_previous ml-3" (click)="authCatlina()" [ngStyle]="{ background: nextButton }">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Catlina process end -->

  <!-- When survey is not loaded -->
  <div class="container survey-container" *ngIf="
      showCaptcha == false &&
      showSurvey == true &&
      showThank == false &&
      showError == false
    ">
    <div class="row">
      <div class="col-lg-12 text-center m-5-per">
        <div class="card">
          <div class="card-body mt-3 mb-3">
            <img src="assets/access-denied.svg" width="200" />
            <h3 class="mt-3">Invalid Survey Access</h3>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- When survey is finished-->
  <div class="container survey-container" *ngIf="
      showCaptcha == false &&
      showThank == true &&
      showThankMsg &&
      showError == false
    ">
    <div class="row">
      <div class="col-lg-12 text-center m-5-per" *ngIf="masterData['_ctl' + finalData['zone']] != 'catalina'">
        <div class="card">
          <div class="card-body mt-5 mb-5">
            <h3 class="mt-3">{{ showThankMsg }}</h3>
          </div>
        </div>
      </div>
      <div class="col-lg-12 m-5-per" *ngIf="(masterData | json) != '{}'">
        <div class="card" *ngIf="masterData['_ctl' + finalData['zone']] == 'catalina'">
          <div class="card-body mt-5 mb-5">
            <div class="col-lg-12">
              <p class="t-j">
                That completes our survey! Thank you again for your
                participation. Your $5 coupon will be printed upon checkout
                during an upcoming shopping trip within the next 4-6 weeks. The
                coupon will look similar to the image shown here:
              </p>
            </div>
            <div class="col-lg-12 text-center">
              <img src="assets/dollar.png" class="mt-5 mb-5 img-responsive" />
            </div>
            <div class="col-lg-12">
              <p>
                Please remember that your customized PIN # is valid for a
                one-time user only and since you have completed the survey, you
                will not be able to log back on.
              </p>
              <br />
              <p>Please be sure you close your browser.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Show error module-->
  <div class="container survey-container" *ngIf="
      showCaptcha == false &&
      showError == true &&
      showErrorMsg &&
      showThank == false
    ">
    <div class="row">
      <div class="col-lg-12 text-center m-5-per">
        <div class="card">
          <div class="card-body mt-3 mb-3">
            <img src="assets/access-denied.svg" width="200" />
            <h3 class="mt-3">{{ showErrorMsg }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Image preview popup -->
  <div class="popup" *ngIf="showPopup">
    <div class="popup-card">
      <span class="close-btn" (click)="closePopup()" (keydown.enter)="closePopup()" role="button" tabindex="0"
        aria-label="Close">&times;</span>
      <img [src]="selectedImage" alt="Selected Preview" />
    </div>
  </div>

  <!-- Hyperlink modal -->
  <div class="modal" id="hyperLink">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-body text-center" style="max-height: 550px; overflow: auto">
          <button type="button" class="close mb-2" data-dismiss="modal" (click)="pauseVideo()">
            &times;
          </button>
          <div *ngFor="let item of surveyDetail?.expandedDetail" class="mt-2">
            <div *ngIf="item.type == 'video'">
              <video src="{{ item.detail }}" class="responsive_video" controls></video>
            </div>
            <div *ngIf="item.type == 'image'">
              <img src="{{ item.detail }}" class="img-responsive" />
            </div>
            <div *ngIf="item.type == 'string'">
              <div [innerHTML]="item.detail | safe : 'html'"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>